// src/polyfill.js

// 1. Fix for "Promise.withResolvers is not a function"
if (typeof Promise.withResolvers === 'undefined') {
    Promise.withResolvers = function () {
        let resolve, reject;
        const promise = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    };
}

// 2. Fix for "URL.parse is not a function"
if (typeof URL.parse === 'undefined') {
    URL.parse = function (url, base) {
        try {
            return new URL(url, base);
        } catch (e) {
            return null;
        }
    };
}

// 3. ⭐ CRITICAL MAC/SAFARI FIX: Object.groupBy and Map.groupBy
// These are used by newer versions of PDF.js but are missing in Safari < 17.4
// Without this, the PDF viewer will crash with "Failed to load PDF file" on many Macs.
if (typeof Object.groupBy === 'undefined') {
    Object.groupBy = function (items, callback) {
        const result = {};
        for (const item of items) {
            const key = callback(item);
            if (!result[key]) {
                result[key] = [];
            }
            result[key].push(item);
        }
        return result;
    };
}

if (typeof Map.groupBy === 'undefined') {
    Map.groupBy = function (items, callback) {
        const result = new Map();
        for (const item of items) {
            const key = callback(item);
            if (!result.has(key)) {
                result.set(key, []);
            }
            result.get(key).push(item);
        }
        return result;
    };
}